<template>
  <BaseDialog
    :isOpen="isOpen"
    :width="1200"
    :fullscreen="isMobile"
    @close="close"
  >
    <template :class="{ container: isMobile }" v-slot:title>
      Edit Experience
    </template>
    <template v-slot:body>
      <ExperienceDetailsForm
        :class="{ container: isMobile }"
        ref="experienceDetailsForm"
        :initialData="formattedExperience"
      />
    </template>
    <template v-slot:actions>
      <PrimaryButton
        @click.native="close"
        text
        :disabled="isLoading"
        v-if="!isMobile"
      >
        Cancel
      </PrimaryButton>
      <PrimaryButton @click.native="onSubmit" :loading="isLoading">
        Save Changes
      </PrimaryButton>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import ExperienceDetailsForm from "@/views/profile/QuestionsAndAnswers/steps/Experience/components/ExperienceDetailsForm";
import { toString } from "lodash";
import { EXPERIENCE_NAMESPACE } from "@/store/modules/users/experience";
import { createNamespacedHelpers } from "vuex";
import { EDIT_USER_EXPERIENCE } from "@/store/modules/users/experience/actions";
import { BASE_DATE_FORMAT, API_DATE_FORMAT } from "@/constants/common";
import { formatDate } from "@/utils/time";

const { mapActions } = createNamespacedHelpers(EXPERIENCE_NAMESPACE);

export default {
  name: "EditExperienceDialog",
  components: {
    PrimaryButton,
    BaseDialog,
    ExperienceDetailsForm
  },
  props: {
    experience: Object,
    isOpen: Boolean
  },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    formattedExperience() {
      return {
        ...this.experience,
        experienceFunctionId: toString(this.experience.experienceFunctionId)
      };
    }
  },
  methods: {
    ...mapActions({
      editUserExperience: EDIT_USER_EXPERIENCE
    }),
    close() {
      this.$emit("close");
    },
    async onSubmit() {
      const isValid = await this.$refs.experienceDetailsForm.validate();
      if (isValid) {
        const experienceData = this.$refs.experienceDetailsForm.getData();
        this.isLoading = true;
        await this.editUserExperience({
          ...experienceData,
          startDate: formatDate({
            date: experienceData.startDate,
            startFormat: BASE_DATE_FORMAT,
            endFormat: API_DATE_FORMAT
          }),
          endDate: formatDate({
            date: experienceData.endDate,
            startFormat: BASE_DATE_FORMAT,
            endFormat: API_DATE_FORMAT
          })
        });
        this.close();
        this.isLoading = false;
      }
    }
  }
};
</script>

<style lang="scss"></style>
